/**
 * Get the display name for a player with appropriate badges
 * @param {Object} player - The player object
 * @param {string} roomCreatorPlayerId - The ID of the room creator
 * @param {string} judgeUsername - The username of the current Judge
 * @param {string} deputyPlayerId - The ID of the deputy/co-host
 * @returns {string} The formatted player display name
 */
export const getPlayerDisplayName = (
  player,
  roomCreatorPlayerId,
  judgeUsername,
  deputyPlayerId
) => {
  if (!player) return 'Unknown Player';

  const username = player.username || 'Unknown';
  const isBot = player.isBot || username.includes('Bot');
  const isRoomCreator =
    player.id === roomCreatorPlayerId || player.playerId === roomCreatorPlayerId;
  const isDeputy =
    deputyPlayerId && (player.id === deputyPlayerId || player.playerId === deputyPlayerId);
  const isJudge = username === judgeUsername;

  // Build display name with badges
  let displayName = isBot ? `🤖 ${username}` : username;

  if (isRoomCreator) {
    displayName += ' ⭐';
  }

  if (isDeputy) {
    displayName += ' 🎖️';
  }

  if (isJudge) {
    displayName += ' ⚖️';
  }

  return displayName;
};
